/**
 * Mock data for the ScatterPlot component
 * Represents deputies, their parties, and performance metrics
 */

// Mock data for deputies
export const deputadosData = [
  {
    id: 1,
    nome: "Dayany do Capitão",
    partido: "UNIÃO",
    estado: "CE",
    foto: "https://randomuser.me/api/portraits/women/1.jpg", // Placeholder image
    desempenho: 45, // Y-axis value (-100 to +100)
    media: 0.7, // X-axis value (0 to 1)
    propostas: 7,
    ranking: 81
  },
  {
    id: 2,
    nome: "Carlos Silva",
    partido: "PT",
    estado: "SP",
    foto: "https://randomuser.me/api/portraits/men/1.jpg",
    desempenho: 65,
    media: 0.8,
    propostas: 12,
    ranking: 23
  },
  {
    id: 3,
    nome: "Ana Rodrigues",
    partido: "PL",
    estado: "RJ",
    foto: "https://randomuser.me/api/portraits/women/2.jpg",
    desempenho: -30,
    media: 0.3,
    propostas: 5,
    ranking: 156
  },
  {
    id: 4,
    nome: "Paulo Mendes",
    partido: "PSOL",
    estado: "MG",
    foto: "https://randomuser.me/api/portraits/men/2.jpg",
    desempenho: 80,
    media: 0.9,
    propostas: 18,
    ranking: 12
  },
  {
    id: 5,
    nome: "Mariana Costa",
    partido: "NOVO",
    estado: "RS",
    foto: "https://randomuser.me/api/portraits/women/3.jpg",
    desempenho: 30,
    media: 0.6,
    propostas: 9,
    ranking: 45
  },
  {
    id: 6,
    nome: "Roberto Alves",
    partido: "MDB",
    estado: "BA",
    foto: "https://randomuser.me/api/portraits/men/3.jpg",
    desempenho: -50,
    media: 0.2,
    propostas: 3,
    ranking: 210
  },
  {
    id: 7,
    nome: "Juliana Santos",
    partido: "PSB",
    estado: "PE",
    foto: "https://randomuser.me/api/portraits/women/4.jpg",
    desempenho: 10,
    media: 0.5,
    propostas: 8,
    ranking: 98
  },
  {
    id: 8,
    nome: "Fernando Lima",
    partido: "PSDB",
    estado: "GO",
    foto: "https://randomuser.me/api/portraits/men/4.jpg",
    desempenho: -10,
    media: 0.4,
    propostas: 6,
    ranking: 120
  },
  {
    id: 9,
    nome: "Carla Oliveira",
    partido: "PDT",
    estado: "SC",
    foto: "https://randomuser.me/api/portraits/women/5.jpg",
    desempenho: 55,
    media: 0.75,
    propostas: 14,
    ranking: 32
  },
  {
    id: 10,
    nome: "Ricardo Pereira",
    partido: "REDE",
    estado: "AM",
    foto: "https://randomuser.me/api/portraits/men/5.jpg",
    desempenho: 25,
    media: 0.55,
    propostas: 10,
    ranking: 67
  },
  // Generate more deputies for each party to create clusters
  ...Array.from({ length: 90 }, (_, i) => {
    const parties = ["PT", "PL", "PSOL", "NOVO", "MDB", "PSB", "PSDB", "PDT", "REDE", "UNIÃO", "PP", "PV", "PSL", "PODE", "AVANTE", "PCdoB", "SOLIDARIEDADE", "CIDADANIA", "PROS", "PSC"];
    const states = ["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"];
    
    const party = parties[Math.floor(Math.random() * parties.length)];
    const basePerformance = {
      "PT": 40,
      "PL": -20,
      "PSOL": 60,
      "NOVO": 20,
      "MDB": -30,
      "PSB": 10,
      "PSDB": 0,
      "PDT": 30,
      "REDE": 50,
      "UNIÃO": 15,
      "PP": -40,
      "PV": 35,
      "PSL": -10,
      "PODE": 5,
      "AVANTE": -5,
      "PCdoB": 45,
      "SOLIDARIEDADE": 25,
      "CIDADANIA": 15,
      "PROS": -15,
      "PSC": -25
    }[party] || 0;
    
    // Add some random variation
    const performanceVariation = Math.floor(Math.random() * 40) - 20;
    const mediaVariation = Math.random() * 0.3 - 0.15;
    
    // Base media for each party
    const baseMedia = {
      "PT": 0.7,
      "PL": 0.3,
      "PSOL": 0.8,
      "NOVO": 0.6,
      "MDB": 0.2,
      "PSB": 0.5,
      "PSDB": 0.4,
      "PDT": 0.65,
      "REDE": 0.55,
      "UNIÃO": 0.45,
      "PP": 0.25,
      "PV": 0.6,
      "PSL": 0.35,
      "PODE": 0.5,
      "AVANTE": 0.4,
      "PCdoB": 0.7,
      "SOLIDARIEDADE": 0.5,
      "CIDADANIA": 0.55,
      "PROS": 0.3,
      "PSC": 0.25
    }[party] || 0.5;
    
    return {
      id: 11 + i,
      nome: `Deputado ${11 + i}`,
      partido: party,
      estado: states[Math.floor(Math.random() * states.length)],
      foto: `https://randomuser.me/api/portraits/${Math.random() > 0.5 ? 'women' : 'men'}/${6 + (i % 70)}.jpg`,
      desempenho: Math.max(-100, Math.min(100, basePerformance + performanceVariation)),
      media: Math.max(0, Math.min(1, baseMedia + mediaVariation)),
      propostas: Math.floor(Math.random() * 20) + 1,
      ranking: Math.floor(Math.random() * 300) + 1
    };
  })
];

// List of all parties
export const partidos = [
  "PT", "PL", "PSOL", "NOVO", "MDB", "PSB", "PSDB", "PDT", "REDE", "UNIÃO", 
  "PP", "PV", "PSL", "PODE", "AVANTE", "PCdoB", "SOLIDARIEDADE", "CIDADANIA", "PROS", "PSC"
];

// List of all states
export const estados = [
  "TODOS", "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", 
  "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", 
  "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"
];

// Helper function to get deputies by party
export const getDeputadosByPartido = (partido) => {
  if (!partido || partido === "TODOS") {
    return deputadosData;
  }
  return deputadosData.filter(dep => dep.partido === partido);
};

// Helper function to get deputies by state
export const getDeputadosByEstado = (estado) => {
  if (!estado || estado === "TODOS") {
    return deputadosData;
  }
  return deputadosData.filter(dep => dep.estado === estado);
};

// Helper function to search deputies by name
export const searchDeputados = (query) => {
  if (!query) {
    return deputadosData;
  }
  const normalizedQuery = query.toLowerCase();
  return deputadosData.filter(dep => 
    dep.nome.toLowerCase().includes(normalizedQuery) || 
    dep.partido.toLowerCase().includes(normalizedQuery) ||
    dep.estado.toLowerCase().includes(normalizedQuery)
  );
};

// Helper function to get color based on performance
export const getPerformanceColor = (desempenho) => {
  if (desempenho > 0) {
    // Positive performance: light green to bright green
    return `rgba(173, 255, 47, 0.8)`;
  } else if (desempenho < 0) {
    // Negative performance: orange to red
    const intensity = Math.min(1, Math.abs(desempenho) / 100);
    return `rgba(255, ${Math.round(165 - (intensity * 100))}, 0, 0.8)`;
  } else {
    // Zero performance: white/transparent
    return `rgba(255, 255, 255, 0.5)`;
  }
};
